import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { getVIPClaim, getVIPRewardInfo } from '@/api/activity';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { useUserStore } from '@/stores/user';
import { VipData } from '@/view/vip/supportScript';
import vipView from '@/themes/themeOne/vip/vipView.vue';
import vipViewTwo from '@/themes/themeTwo/vip/vipView.vue';
import vipViewThree from '@/themes/themeThree/vip/vipView.vue';
import { useThemeStore } from '@/stores/theme';

export default /*@__PURE__*/_defineComponent({
  __name: 'vipView',
  props: {
    isTabView: { type: Boolean }
  },
  setup(__props: any) {

const props = __props
const themeStore = useThemeStore()
const userStore = useUserStore()
const currentLevel = ref(0)
const remainRewards = ref(0)
const progressPercentage = computed(() => 6500 * 100 / 10000);
const { t } = useI18n();
const active = ref(0);
const statusRef = ref();
const toastContent = ref('');
const isSuccess = ref(false);
const loadingRef = ref();
const vipConfigData = ref()
const VIPRewardsInfo = ref<any>({})
const nextLevel = ref(0)
const nextLevelRecord = ref<any>({})
const activity_intro = ref([])

const tabelData = ref([])
const bannerIcon = ref('')
const dataSet = computed<VipData>(() => ({
    currentLevel: currentLevel.value,
    remainRewards: remainRewards.value,
    VIPRewardsInfo: VIPRewardsInfo.value,
    nextLevelRecord: nextLevelRecord.value,
    nextLevel: nextLevel.value,
    active: active.value,
    tabelData: tabelData.value,
    vipConfigData: vipConfigData.value,
    activity_intro: activity_intro.value,
    bannerIcon: bannerIcon.value,
}))
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const getVIPData = () => {
    loadingRef.value.open();
    getVIPRewardInfo().then((res: any) => {
        loadingRef.value.close();
        if (res.data) {
            activity_intro.value = JSON.parse(res.data?.activityIntro)
            bannerIcon.value = res.data?.floatIcon
            remainRewards.value = res.data?.reward
            VIPRewardsInfo.value = res.data?.vipRewardInfo
            currentLevel.value = VIPRewardsInfo.value?.currentVIPLevel
            const highestVipLevel = VIPRewardsInfo.value?.highestVipLevel
            if (currentLevel.value < highestVipLevel) {
                // user still has next level
                nextLevel.value = VIPRewardsInfo.value?.nextVipLevel
            } else {
                // user already at highest level
                nextLevel.value = highestVipLevel
            }

            vipConfigData.value = JSON.parse(res.data?.config)
            nextLevelRecord.value = vipConfigData.value?.level_list.find(
                (item: any) => item.level === nextLevel.value
            )
            tabelData.value = vipConfigData.value?.level_list
    }
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const VIPClaim = () => {
    if (remainRewards.value > 0) {
        loadingRef.value.open();
        let data = {
        uid: userStore.id
    }
        getVIPClaim(data).then((res: any) => {
            loadingRef.value.close();
            showSuccess(res.msg)
            getVIPData()
        }).catch(err => {
            if (err.code != 401) {
                loadingRef.value.close();
                showError(err);
            }
        })
    }
}

onMounted(() => [
    getVIPData()
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(vipView, {
            "data-set": dataSet.value,
            onVIPClaim: VIPClaim,
            active: active.value,
            "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event))
          }, null, 8, ["data-set", "active"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(vipViewTwo, {
            "data-set": dataSet.value,
            onVIPClaim: VIPClaim,
            active: active.value,
            "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((active).value = $event))
          }, null, 8, ["data-set", "active"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(vipViewThree, {
            "data-set": dataSet.value,
            onVIPClaim: VIPClaim,
            active: active.value,
            "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((active).value = $event)),
            "is-tab-view": _ctx.isTabView
          }, null, 8, ["data-set", "active", "is-tab-view"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})